import type { FormSegment } from '../../../types';
import { getSegmentBucket } from '../components/drawer/hooks/utils/segmentReducer';

export const getDirectAndFirstPartySegments = (
  segments: FormSegment[]
): {
  directSegmentValues: FormSegment[];
} => {
  const directSegmentValues: FormSegment[] = [];

  for (const segment of segments) {
    const bucket = getSegmentBucket(segment);

    if (bucket === 'directSegments') {
      directSegmentValues.push(segment);
    }
  }

  return { directSegmentValues };
};
